/*
 * @Descripttion: 说明
 * @Author: 聂章帅
 * @Date: 2021-08-10 16:16:06
 * @LastEditors: 聂章帅
 * @LastEditTime: 2021-11-25 16:20:55
 */
const ajax = function (url,data) {
    const loading = this.$loading({
        lock: true,
        text: '正在加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    var ss = null
    let _this =this
    this.$.ajax({
        url:this.requestUrl+ "api/index/" + url,
        type: 'POST', // 默认为GET
        dataType: 'json',
        async: false,
        data,
        timeout: 5000,
        success: function (result) {
            // console.log(result);
            ss = result;
            loading.close();
          
        },
        error: function () {
            console.log('错误')
            
        }
    })
    return ss
}

export default ajax